module.exports = __webpack_public_path__ + "omlazeni-pleti_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/omlazeni-pleti_2_before.jpg
// module id = 1016
// module chunks = 0